import dynamic from 'next/dynamic';
import getConfig from 'next/config';
import Router from 'next/router';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import is from 'is_js';
import { Dropdown, Menu } from '@bijie/react-bnb';
import memoizeOne from '../utils/memorizeOne';
// $FlowFixMe
import shallowEqual from '../utils/shallowEqual';

import withErrorHandler from '../utils/withErrorHandler';
import { formatNumber } from '../utils/number';
import { getLabel } from '../utils/i18n';
import { setItem } from '../utils/localStorage';
import { OnRowClick } from '../utils/dataTypes';
import SearchInput from './SearchInput';

import ScrollableTable from './ScrollableTable';
import SymbolsRowRenderer from './SymbolsList/SymbolsRowRenderer';
import FlexBox from './FlexBox';
import Icon from './Icon';
import FiatPrice, { getFiatPrice } from './FiatPrice';
import { setInitFavorite as setInitFavoriteAction } from '../actions/actionsSet/assetService';
import {
  setSelectedPair as setSelectedPairAction,
  setSelectedAssetTab as setSelectedAssetTabAction,
} from '../actions/settings';
import { isServer } from '../utils/isServer';
import NoData from './NoData';

import featureConfig from '../config/feature';
import { createCookie } from '../utils/cookies-browser';
import { track, sensorEventTypes } from '../utils/sensors';
import LazyImg from './LazyImg';

const { MenuItem } = Menu;

const {
  publicRuntimeConfig: { assetPrefix },
} = getConfig();

const { defaultSelectedStableCoinTabs } = featureConfig;
const STABLE_COIN_BASES = Object.keys(defaultSelectedStableCoinTabs);

const DEFAULT_WIDTH = 1260;
const DEFAULT_ROW_HEIGHT = 48;
const ROW_HEIGHT = 32;
const FAVORITE_STAR_STYLE = { padding: '8px 14px' };
const ROW_LIMIT = 10;
const ALIGN_RIGHT = { justifyContent: 'flex-end' };
const VOLUME_STYLE = { paddingRight: '20px', ...ALIGN_RIGHT };

const FavoriteStarPlaceholder = () => (
  <i className="iconfont icon-collect" style={FAVORITE_STAR_STYLE} />
);

const FavoriteStar = dynamic(import('./SymbolsList/FavoriteStar'), {
  ssr: false,
  loading: FavoriteStarPlaceholder,
});
const Wrap = styled.div`
  width: 100%;
  height: 805px;
  margin-bottom: 30px;
`;
const SymbolsListBox = styled(FlexBox)`
  box-shadow: 0px 10px 80px 0px rgba(0, 0, 0, 0.04);
  width: 100%;
  height: 805px;
  left: 0;
  top: 0;
  transition: all 0.3s ease-in;
  background: #fff;
  .fiat-price {
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
`;

const Amount = styled.span`
  padding-right: 1px;
`;

const GreenAmount = styled(Amount)`
  color: ${({ theme }) => theme.up};
`;

const GreenAmountPlus = styled(Amount)`
  color: ${({ theme }) => theme.up};
  :before {
    content: '+';
  }
`;
const RedAmount = styled(Amount)`
  color: ${({ theme }) => theme.down};
`;

export const SearchBox = styled(FlexBox)`
  padding: ${({ fullScreen }) => (fullScreen ? '0' : '40px 0')};
  > div {
    padding-bottom: 4px;
    border-bottom: 1px solid #eaecef;
  }
  input {
    border: none;
    font-size: 30px;
    padding-left: ${({ fullScreen }) => (fullScreen ? '30px' : '95px')};
    padding-right: ${({ fullScreen }) => (fullScreen ? '0' : '60px')};
    font-size: ${({ fullScreen }) => (fullScreen ? '24px' : '26px')};
    ::-webkit-input-placeholder {
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: ${({ fullScreen }) => (fullScreen ? '20px' : '24px')};
      color: rgba(132, 142, 156, 0.5) !important;
      line-height: 32px;
    }
    :-moz-placeholder {
      /* Firefox 18- */
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: ${({ fullScreen }) => (fullScreen ? '20px' : '24px')};
      color: rgba(132, 142, 156, 0.5) !important;
      line-height: 32px;
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: ${({ fullScreen }) => (fullScreen ? '20px' : '24px')};
      color: rgba(132, 142, 156, 0.5) !important;
      line-height: 32px;
    }
    :-ms-input-placeholder {
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: ${({ fullScreen }) => (fullScreen ? '20px' : '24px')};
      color: rgba(132, 142, 156, 0.5) !important;
      line-height: 32px;
    }
  }
  .iconfont {
    font-size: ${({ fullScreen }) => (fullScreen ? '16px' : '26px')};
    top: 56%;
    padding-bottom: ${({ fullScreen }) => (fullScreen ? '8px' : '10px')};
    padding-left: ${({ fullScreen }) => (fullScreen ? '0' : '55px')};
  }
`;

export const TabContainer = styled(FlexBox)`
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  > button {
    background: none;
    outline: none;
    border: none;
    position: absolute;
    right: 20px;
    top: 22px;
    line-height: 20px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    color: rgba(33, 40, 51, 1);
    .iconfont {
      margin-left: 8px;
      vertical-align: middle;
      display: inline-block;
      margin-top: -2px;
    }
  }
`;

export const Tabs = styled(FlexBox)`
  position: relative;
  white-space: normal;
  overflow: hidden;
`;
// border-bottom-color: ${({ selected, theme }) => selected ? theme.bg : ''};
export const Tab = styled.button`
  cursor: pointer;
  transition: none;
  user-select: none;
  border: none;
  background: none;
  outline: none;
  font-size: ${({ theme }) => theme.fontSizeLg};
  padding: 20px;
  color: ${({ selected }) => (selected ? '#f5bc00' : '#212833')};
  position: relative;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  :after {
    content: ' ';
    display: inline-block;
    width: 40px;
    height: 3px;
    background: ${({ theme }) => theme.highlight};
    position: absolute;
    bottom: 0;
    left: ${({ isStableCoinMarket }) => (isStableCoinMarket ? 'calc(50% - 40px)' : '50%')};
    transform: translateX(-50%);
  }
  ${({ selected }) => (selected ? ':after {display: block};' : ':after {display: none};')}
`;

const TableBox = styled(FlexBox)`
  height: ${({ height }) => height}px;
  .ReactVirtualized__Table__headerRow {
    background: none !important;
    border-color: rgba(234, 236, 239, 0.6);
  }
  .ReactVirtualized__Table__rowColumn {
    font-size: ${({ fontSize }) => fontSize};
  }
  .ReactVirtualized__Table__headerColumn {
    border-right: none !important;
  }
  .ReactVirtualized__Table__row {
    border-bottom: 1px solid rgba(234, 236, 239, 0.6);
  }
  .ReactVirtualized__Table__row:hover {
    background: rgba(234, 236, 239, 0.4) !important;
  }
  .ReactVirtualized__Table__headerTruncatedText {
    color: #848e9c;
    line-height: 20px;
  }
`;

const FullScreenBox = styled(FlexBox)`
  width: 100%;
  height: 96px;
  border-radius: 10px;
  background: #fff;
  > button {
    cursor: pointer;
    color: #212833;
    border: none;
    outline: none;
    background: none;
  }
  .iconfont {
    margin-left: 8px;
    vertical-align: middle;
    display: inline-block;
    margin-top: -2px;
  }
`;

const SymbolBox = styled.div`
  > strong {
    font-size: 14px;
    font-weight: 500;
    color: rgba(33, 40, 51, 1);
    line-height: 22px;
    font-weight: 500;
  }
  > span {
    font-size: ${({ fullScreen }) => (fullScreen ? '12px' : '14px')};
    font-weight: 500;
    color: rgba(132, 142, 156, 1);
    line-height: 18px;
  }
`;

export const SelectMarketsBox = styled.span`
  display: inline-block;
  margin-left: 10px;
  height: 22px;
  width: 70px;
  padding: 0 22px 0 10px;
  border-radius: 11px;
  background: #fff;
  border: 1px solid #eaecef;
  font-size: 14px;
  font-weight: 500;
  color: rgba(132, 142, 156, 1);
  line-height: 20px;
  outline: none;
  cursor: pointer;
  position: relative;
  .iconfont {
    position: absolute;
    right: 10px;
    top: 0px;
    line-height: 22px;
    transform: scale(0.8);
  }
`;

const StyledMoreButton = styled.button`
  :hover,
  :hover i {
    color: #f0b90b;
  }
  i {
    font-size: 10px;
  }
`;

const mapStateToProps = ({
  tickers,
  locale,
  favorites,
  selectedAssetTab,
  fiatRate,
  currencyList,
  userPreferredCurrency,
}) => ({
  tickers,
  locale,
  favorites,
  selectedAssetTab,
  fiatRate,
  currencyList,
  userPreferredCurrency,
});
const mapDispatchToProps = {
  setInitFavorite: setInitFavoriteAction,
  setSelectedPair: setSelectedPairAction,
  setSelectedAssetTab: setSelectedAssetTabAction,
};

export default
@withErrorHandler
@connect(
  mapStateToProps,
  mapDispatchToProps
)
class SymbolsList extends Component {
  static propTypes = {
    tickers: PropTypes.object,
    i18n: PropTypes.object,
    locale: PropTypes.string,
    favorites: PropTypes.array,
    pro: PropTypes.bool,
    callbackToggleFn: PropTypes.func,
    setInitFavorite: PropTypes.func.isRequired,
    setSelectedPair: PropTypes.func,
    setSelectedAssetTab: PropTypes.func,
  };

  static defaultProps = {
    tickers: [],
    i18n: {},
    locale: '',
    favorites: [],
    pro: false,
    callbackToggleFn: () => {},
    setSelectedPair: () => {},
    setSelectedAssetTab: () => {},
    selectedAssetTab: 'BTC',
  };

  _tick = null;

  _priceColor = {};

  _lastPriceCollection = {};

  constructor(props) {
    super(props);
    const { tickers } = this.props;
    Object.keys(tickers).map(item => {
      this._priceColor[item] = 0;
      this._lastPriceCollection[item] = [1];
      return null;
    });

    this.state = {
      filterByAsset: 'BTC',
      filterKeyword: '',
      sortDirection: 'DESC',
      sortBy: 'q',
      showFavorites: false,
      fullScreen: false,
      selectedCoin: {
        'USDⓈ': 'ALL',
        'ALTS': 'ALL',
      },
      tick: null,
    };
    this._windowScroller = React.createRef();
  }

  componentDidMount() {
    /* eslint-disable */
    // fix issue when refresh while scrolled half way down the page
    setTimeout(() => {
      const { scrollTop } = document.documentElement;

      if (is.number(scrollTop) && scrollTop === 0) return;

      const { current } = this._windowScroller;

      if (!current) return;
      current.__handleWindowScrollEvent && current.__handleWindowScrollEvent();

      // reset isScrolling to false.
      current.__resetIsScrolling && current.__resetIsScrolling();
    }, 0);

    this._tick = setInterval(() => this.setState({ tick: Date.now() }), 5000);

    // init favorites
    this.props.setInitFavorite();
    if (!isServer) {
      if (sessionStorage.getItem('filterByAsset')) {
        if (!isServer)
          this.setState({ filterByAsset: sessionStorage.getItem('filterByAsset') || '' });
      }
      if (sessionStorage.getItem('showFavorites')) {
        if (!isServer)
          this.setState({
            showFavorites: JSON.parse(sessionStorage.getItem('showFavorites') || 'false'),
          });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState): boolean {
    return (
      !shallowEqual(nextState, this.state) ||
      (is.empty(this.props.fiatRate) && !is.empty(nextProps.fiatRate))
    );
  }

  componentDidUpdate() {
    const { tickers } = this.props;

    // update price color
    const tickersArr = Object.entries(tickers);
    const priceColor = {};
    tickersArr.map((item: [string, Ticker | any]) => {
      const { s, c } = item[1];
      const prevPrice = this._lastPriceCollection[s];
      if (Number(c) > Number(prevPrice)) {
        priceColor[s] = 1;
      } else if (Number(c) === Number(prevPrice)) {
        priceColor[s] = 0;
      } else {
        priceColor[s] = -1;
      }
      this._lastPriceCollection[s] = c;
      return null;
    });
    this._priceColor = priceColor;
  }

  componentWillUnmount() {
    window.document.body.style.overflow = 'auto';
    if (this._tick) clearInterval(this._tick);
  }

  // e.g. BTC, ETH, BNB, USDT, ...
  _getParentMarketNames() {
    const { tickers } = this.props;
    const arr = [];
    Object.values(tickers).map(v => {
      const { pn } = v;
      if (!arr.includes(pn)) {
        arr.push(pn);
      }
      return null;
    });
    return arr;
  }

  _getMarketCup = cellData => {
    const { cs, qa: quoteAsset, c: price } = cellData;
    const { fiatRate, currencyList, userPreferredCurrency: preferredCurrency, locale } = this.props;
    const lastPrice = getFiatPrice({
      fiatRate,
      currencyList,
      preferredCurrency,
      locale,
      quoteAsset,
      price,
      prefix: '',
    });
    if (!lastPrice)
      return {
        value: 0,
        symbol,
      };
    const { fiatPrice, symbol } = lastPrice;
    const value = Number(fiatPrice) * Number(cs);
    return {
      value,
      symbol,
    };
  };

  _formatMarketCup = (value, symbol) => {
    if (value > 0 && value < 1000000) return `${symbol}${formatNumber(value, 2)}`;
    if (value > 1000000) return `${symbol}${formatNumber(value / 1000000, 2)}M`;
    return '-';
  };

  _getFavorites() {
    return this.props.favorites;
  }

  _handleForceUpdate = () => {
    this.setState({ tick: Date.now() });
  };

  _cellGetter = ({ rowData }) => rowData[1];

  _cellRendererFavorite = ({ rowData }) => {
    const { favorites = [] } = this.props;
    const symbol = rowData[0];
    const active = favorites.includes(symbol);

    return (
      <FavoriteStar
        key={symbol}
        style={FAVORITE_STAR_STYLE}
        symbol={symbol}
        active={active}
        handleForceUpdate={this._handleForceUpdate}
      />
    );
  };

  _cellRendererMarketCap = ({ cellData }) => {
    const { value, symbol } = this._getMarketCup(cellData);
    return this._formatMarketCup(value, symbol);
  };

  _cellRendererMarkets = ({ cellData }) => (
    <LazyImg
      key={cellData.s}
      src={`${assetPrefix}/kline/${cellData.s}.svg`}
      alt={cellData.s}
      width="100"
      height="30"
    />
  );

  // TODO: implement conditional

  _cellRendererVolume = ({ cellData }) => {
    const { q } = cellData;
    return formatNumber(q, 2);
  };

  _cellRendererPair = ({ cellData }) => {
    const { ba, qa } = cellData;
    return (
      <SymbolBox>
        <strong>{ba}</strong>&nbsp;
        <span>/&nbsp;{qa}</span>
      </SymbolBox>
    );
  };

  _cellRendererFullName = ({ cellData }) => {
    const { bn } = cellData;
    return bn;
  };

  _cellRendererPrice = (cellData, priceColor) => {
    if (cellData) {
      const { c, qa, s, tickSize } = cellData;
      const tk = Math.abs(Math.log10(tickSize));
      const colorState = priceColor[s];
      const price = formatNumber(c, tk);
      if (colorState === 1) {
        return (
          <FlexBox>
            <GreenAmount>{price}</GreenAmount>
            <FiatPrice prefix="/ " price={c} quoteAsset={qa} precision={2} color="#848E9C" />
          </FlexBox>
        );
      } else if (colorState === 0) {
        return (
          <FlexBox>
            <Amount>{price}</Amount>
            <FiatPrice prefix="/ " price={c} quoteAsset={qa} precision={2} color="#848E9C" />
          </FlexBox>
        );
      }
      return (
        <FlexBox>
          <RedAmount>{price}</RedAmount>
          <FiatPrice prefix="/ " price={c} quoteAsset={qa} precision={2} color="#848E9C" />
        </FlexBox>
      );
    }
    return null;
  };

  _cellRendererChange = ({ cellData }) => {
    if (cellData) {
      if (!Number(cellData.o)) return <Amount>–</Amount>;
      const change = ((cellData.c - cellData.o) / cellData.o) * 100;
      if (change > 0) {
        return <GreenAmountPlus>{formatNumber(change, 2)}%</GreenAmountPlus>;
      }
      return <RedAmount>{formatNumber(change, 2)}%</RedAmount>;
    }
    return null;
  };

  _searchByKeyword = val => {
    if (this.state.filterKeyword.length === 0 && val.length !== 0) {
      track(sensorEventTypes.HOMEPAGE_PAIR_SEARCH);
    }
    this.setState({
      filterKeyword: val,
    });
  };

  _sort = ({ sortBy, sortDirection }) => {
    if (sortBy === '') return;
    this.setState({ sortBy, sortDirection });
  };

  _sortList = (sortBy, sortDirection, sortResource) =>
    sortResource.sort((a, b) => {
      const aCh = (a[1].c - a[1].o) / a[1].o;
      const bCh = (b[1].c - b[1].o) / b[1].o;
      const aMarketCup = this._getMarketCup(a[1]);
      const bMarketCup = this._getMarketCup(b[1]);
      if (sortDirection === 'DESC') {
        if (sortBy === 'ch') {
          if (Number.isNaN(aCh) || Number.isNaN(bCh)) {
            return Number.isNaN(aCh) ? 1 : -1;
          } else if (!Number.isFinite(aCh) && !Number.isFinite(bCh)) {
            return a[0] > b[0] ? 1 : -1;
          } else if (!Number.isFinite(aCh)) {
            return 1;
          }
          return bCh - aCh;
        } else if (sortBy === 's') {
          return b[1][sortBy].localeCompare(a[1][sortBy]);
        } else if (sortBy === 'cs') {
          return bMarketCup.value - aMarketCup.value;
        }
        return b[1][sortBy] - a[1][sortBy];
      }
      if (sortBy === 'ch') {
        if (Number.isNaN(aCh) || Number.isNaN(bCh)) {
          return Number.isNaN(aCh) ? 1 : -1;
        } else if (!Number.isFinite(aCh) && !Number.isFinite(bCh)) {
          return a[0] < b[0] ? 1 : -1;
        } else if (!Number.isFinite(aCh)) {
          return 1;
        }
        return aCh - bCh;
      } else if (sortBy === 's') {
        return a[1][sortBy].localeCompare(b[1][sortBy]);
      } else if (sortBy === 'cs') {
        return aMarketCup.value - bMarketCup.value;
      }
      return a[1][sortBy] - b[1][sortBy];
    });

  _rowRenderer = props => <SymbolsRowRenderer {...props} />;

  _onRowClick = ({ index }: OnRowClick) => {
    if (this.props.pro) this.props.callbackToggleFn();
    const pairLabel = 'bn.selectedPair';
    setItem(
      window.localStorage,
      pairLabel,
      `${this._sortedList[index][1].ba}_${this._sortedList[index][1].qa}`
    );
    this.props.setSelectedPair(`${this._sortedList[index][1].ba}_${this._sortedList[index][1].qa}`);
  };

  _handleFavoriteTab = () => {
    this.setState({ showFavorites: true });
    createCookie('defaultAssetTab', 'favorites');
    this.props.setSelectedAssetTab('favorites');
    sessionStorage.setItem('showFavorites', true);
  };

  _handleAssetTab = val => {
    this.setState({ filterByAsset: val, showFavorites: false });
    createCookie('defaultAssetTab', val === 'USDⓈ' ? 'USD' : val);
    this.props.setSelectedAssetTab(val);
    sessionStorage.setItem('filterByAsset', val);
    sessionStorage.setItem('showFavorites', false);
  };

  _getTableBoxHeight = (sortedList: Array<Object>, rowHeight: number) => {
    const { fullScreen } = this.state;
    const { length } = sortedList;
    if (!fullScreen) return (length >= ROW_LIMIT ? ROW_LIMIT : length) * rowHeight + rowHeight;
    if (fullScreen) return length === 0 ? rowHeight : '100vh' - 124;
  };

  _getParentMarketNamesAndStableCoins = () => {
    const { tickers } = this.props;
    const stableCoins = {};
    STABLE_COIN_BASES.forEach(el => {
      stableCoins[el] = ['ALL'];
    });
    const list = Object.values(tickers);
    list.forEach(({ pn, qa }) => {
      STABLE_COIN_BASES.forEach((el: string) => {
        if (el === pn && STABLE_COIN_BASES.includes(pn) && !stableCoins[el].includes(qa)) {
          stableCoins[el].push(qa);
        }
      });
    });
    return stableCoins;
  };

  _handleMoreList = () => {
    const { locale } = this.props;
    Router.push(`/${locale}/markets`);
  };

  _handleTabClick = key => {
    const { selectedAssetTab } = this.props;
    const { selectedCoin } = this.state;
    let newSelectedCoin = Object.assign({}, selectedCoin);
    newSelectedCoin[selectedAssetTab] = key;
    this.setState({
      selectedCoin: newSelectedCoin,
    });
  };

  render() {
    const { i18n, tickers, pro, selectedAssetTab } = this.props;
    const {
      filterByAsset,
      filterKeyword,
      sortBy,
      sortDirection,
      showFavorites,
      fullScreen,
      selectedCoin,
    } = this.state;

    const entries = Object.entries(tickers);
    const filteredList = () => {
      if (selectedAssetTab === 'favorites') {
        return entries.filter(([s]) => this._getFavorites().includes(s));
      } else if (
        STABLE_COIN_BASES.includes(selectedAssetTab) &&
        selectedCoin[selectedAssetTab] !== 'ALL'
      ) {
        return entries.filter(
          ticker =>
            ticker[1].pn === selectedAssetTab &&
            ticker[1].qa &&
            ticker[1].qa === selectedCoin[selectedAssetTab]
        );
      } else {
        return entries.filter(ticker => ticker[1].pn === selectedAssetTab);
      }
    };
    const memorizeFilteredList = memoizeOne(filteredList);
    const _filteredList = memorizeFilteredList(selectedAssetTab);

    const filterKeywordLower = filterKeyword && filterKeyword.toLowerCase();
    const searchedList = () =>
      _filteredList.filter(
        ([, { bn, ba }]) =>
          (ba && ba.toLowerCase().includes(filterKeywordLower)) ||
          (!is.undefined(bn) && !pro && bn.toLowerCase().includes(filterKeywordLower))
      );
    const memorizeSearchedList = memoizeOne(searchedList);
    const _searchedList = memorizeSearchedList(filterKeywordLower);

    const memorizedSort = memoizeOne(this._sortList);
    const sortedList = (this._sortedList = memorizedSort(sortBy, sortDirection, _searchedList));
    const parentMarkets = this._getParentMarketNames();
    const tableWidth = fullScreen ? window.document.body.offsetWidth - 100 : DEFAULT_WIDTH;
    const rowHeight = fullScreen ? ROW_HEIGHT : DEFAULT_ROW_HEIGHT;
    const tableBoxHeight = this._getTableBoxHeight(sortedList, rowHeight);
    const stableCoins = this._getParentMarketNamesAndStableCoins();
    return (
      <Wrap>
        <SymbolsListBox flex="1" direction="column" wrap="nowrap" fullScreen={fullScreen}>
          {!fullScreen && (
            <SearchBox fullScreen={fullScreen} justify="center" align="center">
              <SearchInput
                value={filterKeyword}
                placeholder={getLabel('exchange-home-SearchCoinName', i18n)}
                onChange={this._searchByKeyword}
                height="auto"
                width="350px"
              />
            </SearchBox>
          )}

          <TabContainer id="tabContainer" align="center">
            <Tabs>
              <Tab
                selected={selectedAssetTab === 'favorites'}
                id="home-button-favorites"
                onClick={this._handleFavoriteTab}
              >
                {getLabel('exchange-home-Favorites', i18n)}
              </Tab>
              {parentMarkets.map((v, i) => (
                <Tab
                  id={`IndexSymbolsList-button-${v}Markets`}
                  key={i}
                  selected={selectedAssetTab === v && !showFavorites}
                  isStableCoinMarket={STABLE_COIN_BASES.includes(v)}
                  onClick={() => this._handleAssetTab(v)}
                >
                  {getLabel('exchange-home-Markets', i18n).replace('##', v)}
                  {STABLE_COIN_BASES.includes(v) && (
                    <Dropdown
                      overlay={
                        <Menu mode="inline">
                          {stableCoins[v].map(item => (
                            <MenuItem key={item} onClick={() => this._handleTabClick(item)}>
                              {item === 'ALL' ? <Icon type="hamburger" size={12} /> : '-'}
                              &nbsp;&nbsp;{item}
                            </MenuItem>
                          ))}
                        </Menu>
                      }
                      trigger={['click']}
                    >
                      <SelectMarketsBox>
                        {selectedCoin[v]}
                        <Icon type="arrow-d" size={12} color="#848E9C" />
                      </SelectMarketsBox>
                    </Dropdown>
                  )}
                </Tab>
              ))}
            </Tabs>
            {!fullScreen && (
              <StyledMoreButton
                type="button"
                id="home-button-viewMoreMarkets1"
                onClick={this._handleMoreList}
                data-role="top"
              >
                {getLabel('exchange-home-viewMoreMarkets', i18n)}
                &nbsp;»
              </StyledMoreButton>
            )}
            {fullScreen && (
              <SearchBox fullScreen={fullScreen} justify="center" align="center">
                <SearchInput
                  id="viewMoreMarkets-input-SearchCoinName"
                  value={filterKeyword}
                  placeholder={getLabel('exchange-home-SearchCoinName', i18n)}
                  onChange={this._searchByKeyword}
                  height="auto"
                  width="400px"
                />
              </SearchBox>
            )}
          </TabContainer>

          <TableBox
            flex={sortedList.length === 0 ? 'none' : '1 0 auto'}
            margin={fullScreen ? '0 0 20px 0' : '0'}
            height={tableBoxHeight}
            fontSize={fullScreen ? '12px' : '14px'}
          >
            <ScrollableTable
              defaultWidth={DEFAULT_WIDTH}
              defaultHeight={
                (fullScreen
                  ? sortedList.length
                  : sortedList.length >= ROW_LIMIT
                  ? ROW_LIMIT
                  : sortedList.length) * rowHeight
              }
              headerHeight={rowHeight}
              rowHeight={rowHeight}
              rowCount={
                fullScreen
                  ? sortedList.length
                  : sortedList.length >= ROW_LIMIT
                  ? ROW_LIMIT
                  : sortedList.length
              }
              rowGetter={({ index }) => sortedList[index]}
              rowRenderer={this._rowRenderer}
              sort={this._sort}
              sortBy={sortBy}
              sortDirection={sortDirection}
              onRowClick={this._onRowClick}
              showFavorites={selectedAssetTab === 'favorites'}
              filterKeyword={filterKeywordLower}
              scrollable={fullScreen}
              {...this.props}
            >
              <ScrollableTable.Column
                label=""
                dataKey=""
                width={tableWidth * 0.05}
                flexShrink={0}
                cellRenderer={this._cellRendererFavorite}
                disableSort={true}
              />
              <ScrollableTable.Column
                label={getLabel('exchange-home-Pair', i18n)}
                dataKey="s"
                width={tableWidth * 0.2}
                flexGrow={1}
                cellDataGetter={this._cellGetter}
                cellRenderer={this._cellRendererPair}
              />
              {fullScreen && (
                <ScrollableTable.Column
                  label={getLabel('exchange-Filter-Coin', i18n)}
                  dataKey="s"
                  width={tableWidth * 0.2}
                  flexGrow={1}
                  cellDataGetter={this._cellGetter}
                  cellRenderer={this._cellRendererFullName}
                />
              )}
              <ScrollableTable.Column
                label={getLabel('exchange-home-lastPrice', i18n)}
                dataKey="c"
                width={tableWidth * 0.17}
                cellDataGetter={this._cellGetter}
                cellRenderer={cellData =>
                  this._cellRendererPrice(cellData.cellData, this._priceColor)
                }
              />
              <ScrollableTable.Column
                label={getLabel('exchange-home-24h-change', i18n)}
                dataKey="ch"
                width={tableWidth * 0.1}
                cellDataGetter={this._cellGetter}
                cellRenderer={this._cellRendererChange}
                headerStyle={ALIGN_RIGHT}
                style={ALIGN_RIGHT}
              />

              <ScrollableTable.Column
                label={getLabel('exchange-home-marketCap', i18n)}
                dataKey="cs"
                width={tableWidth * 0.18}
                cellDataGetter={this._cellGetter}
                cellRenderer={this._cellRendererMarketCap}
                headerStyle={ALIGN_RIGHT}
                style={ALIGN_RIGHT}
              />

              {!fullScreen && (
                <ScrollableTable.Column
                  label={getLabel('exchange-home-tableMarkets', i18n)}
                  dataKey=""
                  width={tableWidth * 0.16}
                  cellDataGetter={this._cellGetter}
                  cellRenderer={this._cellRendererMarkets}
                  headerStyle={ALIGN_RIGHT}
                  style={ALIGN_RIGHT}
                />
              )}

              <ScrollableTable.Column
                label={getLabel('exchange-home-24h-volume', i18n)}
                dataKey="q"
                width={tableWidth * 0.2}
                cellDataGetter={this._cellGetter}
                cellRenderer={this._cellRendererVolume}
                headerStyle={VOLUME_STYLE}
                style={VOLUME_STYLE}
              />
            </ScrollableTable>
          </TableBox>
          {sortedList.length === 0 ?
            <NoData
              msg={getLabel('exchange-EmptyTable-NoRecordsFound', i18n)}
            />
            : null}
          {!fullScreen && (
            <FullScreenBox justify="center" align="center">
              <StyledMoreButton
                type="button"
                id="home-button-viewMoreMarkets2"
                onClick={this._handleMoreList}
                data-role="bottom"
              >
                {getLabel('exchange-home-viewMoreMarkets', i18n)}
                &nbsp;»
              </StyledMoreButton>
            </FullScreenBox>
          )}
        </SymbolsListBox>
      </Wrap>
    );
  }
}
